import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Link } from '@vk-hr-tek/ui/Link';
import { Icon } from '@vk-hr-tek/ui/Icon';

import { SearchFilestoragesOption } from '../SearchInput.types';

const getIcon = (kind: SearchFilestoragesOption['kind']) => {
  switch (kind) {
    case 'folder':
      return 'folder_simple_outline';
    case 'file':
      return 'document_outline';
    default:
      const exhaustiveCheck: never = kind;

      return exhaustiveCheck;
  }
};

interface SearchOptionFilestorageProps {
  option: SearchFilestoragesOption;
}

export const SearchOptionFilestorage = ({
  option,
}: SearchOptionFilestorageProps) => {
  return (
    <Box width="100%" p="8">
      <Link href={option.link} variant="simple" display="block">
        <Box display="flex" alignItems="center" gap="12">
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            radius="m"
            bgcolor="bg.greyscale.secondary"
            minHeight="40px"
            minWidth="40px"
            height="40px"
            width="40px"
          >
            <Icon
              name={getIcon(option.kind)}
              color="accent.text.warning"
              size="24"
            />
          </Box>
          <Typography
            maxLinesCount={2}
            variant="body3"
            color="text.light.primary"
            wordBreak="break-all"
          >
            {option.name}
          </Typography>
        </Box>
      </Link>
    </Box>
  );
};
